<template>
    <div class="form-check">
        <b-row>
            <b-col>
                <b-form-checkbox
                    size="lg"
                    :disabled="areUnsavedFeatures"
                    v-model="layer.active"
                    @change="layerVisibilityChanged"
                    >
                    {{ layer.name }}
                    <b-badge
                        variant="secondary"
                        pill
                        v-b-tooltip.hover :title="getFeatureCountDetail"
                        >
                        {{getFeatureCount}}
                    </b-badge>
                    &nbsp;
                    <b-badge
                        v-show="getEditingFeatureCount"
                        variant="warning"
                        pill
                        >
                        {{getEditingFeatureCount}}
                    </b-badge>
                    <b-link variant="link" @click="downloadGPX" v-b-tooltip.hover title="Télécharger le GPX">
                        <font-awesome-icon :icon="['fas', 'file-download']"></font-awesome-icon>
                    </b-link>
                </b-form-checkbox>
            </b-col>
            <b-col cols="auto" class="pl-0">
                <b-button variant="outline-secondary" @click="collapse_visible = !collapse_visible" size="sm">
                    <font-awesome-icon v-show="!collapse_visible" :icon="['fas', 'chevron-down']"></font-awesome-icon>
                    <font-awesome-icon v-show="collapse_visible" :icon="['fas', 'chevron-up']"></font-awesome-icon>
                </b-button>
            </b-col>
        </b-row>
        <b-collapse v-model="collapse_visible">
            <WaypointFeature
                v-on="$listeners"
                :linked-feature=feature
                v-for="feature in layer.openraideur_waypoint_features"
                :key="'waypoint' + feature.id"
                />
            <RaceFeature
                v-on="$listeners"
                :linked-feature=feature
                v-for="feature in layer.openraideur_race_features"
                :key="'race' + feature.id"
                />
        </b-collapse>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faPencilAlt)

import RaceFeature from "./RaceFeature"
import WaypointFeature from "./WaypointFeature"

const axios = require('axios').default;

export default {
    name: 'LayerPanel',
    props: {
        linkedLayer : Object
    },
    components: {
        RaceFeature,
        WaypointFeature,
        FontAwesomeIcon
    },
    data: function () {
        return {
            layer : this.linkedLayer,
            collapse_id: "collapse-layer-" + this.linkedLayer.id,
            collapse_visible: false
        }
    },
    computed: {
        getFeatureCount() {
            return this.layer.openraideur_race_features.length + this.layer.openraideur_waypoint_features.length;
        },
        getFeatureCountDetail() {
            return this.layer.openraideur_waypoint_features.length + " marqueurs et " + this.layer.openraideur_race_features.length + " parcours";
        },
        getEditingFeatureCount() {
            return this.layer.openraideur_race_features.filter(f => f.editState == true).length + this.layer.openraideur_waypoint_features.filter(f => f.editState == true).length;
        },
        areUnsavedFeatures() {
            return this.getEditingFeatureCount > 0;
        }
    },
    methods: {
        layerVisibilityChanged(state) {
            this.collapse_visible = state;
            this.$emit('layer-visibility-changed', this.layer.id, state);
        },
        downloadGPX() {
            axios.get('/api/layer/' + this.layer.id + "/gpx/")
            .then(response => {
                var element = document.createElement('a');
                element.setAttribute('href', 'data:application/gpx+xml;charset=utf-8,' + encodeURIComponent(response.data));
                element.setAttribute('download', this.layer.name + ".gpx");

                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            })
            .catch(error => {
                console.log(error);
            })
        }
    }
}
</script>


<style scoped>

</style>